import Icon from '../components/Icon.vue'

Icon.register({
  'arrows-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M352.2 425.8l-79.2 79.2c-9.4 9.4-24.6 9.4-33.9 0l-79.2-79.2c-15.1-15.1-4.4-41 17-41h51.2l0-100.8h-100.8v51.2c0 21.4-25.9 32.1-41 17l-79.2-79.2c-9.4-9.4-9.4-24.6 0-33.9l79.2-79.2c15.1-15.1 41-4.4 41 17v51.2h100.8v-100.8h-51.2c-21.4 0-32.1-25.9-17-41l79.2-79.2c9.4-9.4 24.6-9.4 33.9 0l79.2 79.2c15.1 15.1 4.4 41-17 41h-51.2v100.8h100.8v-51.2c0-21.4 25.9-32.1 41-17l79.2 79.2c9.4 9.4 9.4 24.6 0 33.9l-79.2 79.2c-15.1 15.1-41 4.4-41-17v-51.2h-100.8v100.8h51.2c21.4 0 32.1 25.9 17 41z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-alt.js
// module id = 626
// module chunks = 0